import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  PostLoginQuery,
  PostLoginResponse,
} from '~/lib/services/api/user'

import type { PostLoginRequest } from '~/modules/login/login-form/constants'
import {
  useMutation,
} from '@tanstack/react-query'
import {
  postLogin,
} from '~/lib/services/api/user'

function useLogin() {
  const mutationFn: PostLoginQuery = async (newData) => {
    const response = await postLogin(newData)
    return response.data
  }

  const options: UseMutationOptions<
    PostLoginResponse,
    DefaultError,
    PostLoginRequest,
    unknown
  > = {
    mutationFn,
  }

  return useMutation(options)
}

export default useLogin
